export default "__VITE_ASSET__DWth30iM__"